import React from 'react';
import './Button.css';

interface ButtonProps {
  text: string;
  emoji?: string;
  onClick: () => void;
  theme?: 'light' | 'dark';
  size?: 'small' | 'normal' | 'large';
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  emoji,
  onClick,
  theme = 'dark',
  size = 'normal',
  className = ''
}) => {
  return (
    <button
      className={`custom-button ${theme} ${size} ${className}`}
      onClick={onClick}
    >
      {emoji && <span className="button-emoji">{emoji}</span>}
      {text}
    </button>
  );
};

export default Button;
